module.exports = __webpack_public_path__ + "images/store_case_study/kaitoribusters-pic1_24b40c77bdfb35249316c6b28c362b07.png";